import React, { useEffect } from 'react';
import { translations } from 'src/constants/translations';
import { Box } from '@mui/material';
import { BoxFormAutocomplete } from 'src/components/profileComponents/FormAutocomplete';
import {
  IComplex, ISpecificationProp,
} from 'src/typings/complexes';
import { useGetDeveloperSpecifications } from 'src/hooks/useGetDeveloperSpecifications';
import { DeveloperPropertyType } from 'src/components/profileComponents/Developers/components/types';
import {
  IDevelopmentSpecificationPropChange,
} from 'src/components/profileComponents/Complexes/components/ProjectSpecification/types';

export const ProjectSpecification: React.FC<{
  register: any,
  complex: IComplex | undefined,
  propName: string,
  defaultValues: any,
  onChange?: (data: ISpecificationProp[], prop: string) => void
}> = ({
  complex, defaultValues, register, onChange, propName,
}) => {
  const {
    purchaseTermsOptions,
    propertyClassesOptions,
    salesStatusesOptions,
    constructionPhasesOptions,
    completionDatesOptions,
    fetchSpecifications,
  } = useGetDeveloperSpecifications(complex?.developers[0]);

  useEffect(() => {
    fetchSpecifications();
  }, []);

  const _onChange = (data: IDevelopmentSpecificationPropChange<ISpecificationProp>, prop: string) => {
    const value = Array.isArray(data) ? data.map((item) => item.value) : data.value ? [data.value] : [];
    if (onChange) {
      onChange(value, prop);
    }
  };

  return (
    <>
      <Box flex="1" display="flex" gap="40px">
        <BoxFormAutocomplete
          multiple
          label={translations.purchaseTerms}
          name={`${propName}.${DeveloperPropertyType.purchaseTerms}`}
          options={purchaseTermsOptions}
          defaultValue={defaultValues[DeveloperPropertyType.purchaseTerms]}
          onChange={(data: IDevelopmentSpecificationPropChange<ISpecificationProp>) => _onChange(data, `${propName}.${DeveloperPropertyType.purchaseTerms}`)}
          {...register(`${propName}.${DeveloperPropertyType.purchaseTerms}`)}
        />
        <BoxFormAutocomplete
          label={translations.propertyClass}
          name={`${propName}.${DeveloperPropertyType.propertyClasses}`}
          options={propertyClassesOptions}
          defaultValue={defaultValues[DeveloperPropertyType.propertyClasses]}
          onChange={(data: IDevelopmentSpecificationPropChange<ISpecificationProp>) => _onChange(data, `${propName}.${DeveloperPropertyType.propertyClasses}`)}
          {...register(`${propName}.${DeveloperPropertyType.propertyClasses}`)}
        />
      </Box>
      <Box flex="1" display="flex" gap="40px">
        <BoxFormAutocomplete
          label={translations.salesStatus}
          name={`${propName}.${DeveloperPropertyType.salesStatuses}`}
          options={salesStatusesOptions}
          defaultValue={defaultValues[DeveloperPropertyType.salesStatuses]}
          onChange={(data: IDevelopmentSpecificationPropChange<ISpecificationProp>) => _onChange(data, `${propName}.${DeveloperPropertyType.salesStatuses}`)}
          {...register(`${propName}.${DeveloperPropertyType.salesStatuses}`)}
        />
        <BoxFormAutocomplete
          label={translations.constructionPhase}
          name={`${propName}.${DeveloperPropertyType.constructionPhases}`}
          options={constructionPhasesOptions}
          defaultValue={defaultValues[DeveloperPropertyType.constructionPhases]}
          onChange={(data: IDevelopmentSpecificationPropChange<ISpecificationProp>) => _onChange(data, `${propName}.${DeveloperPropertyType.constructionPhases}`)}
          {...register(`${propName}.${DeveloperPropertyType.constructionPhases}`)}
        />
      </Box>
      <Box flex="1" display="flex" gap="40px">
        <BoxFormAutocomplete
          label={translations.completionDate}
          name={`${propName}.${DeveloperPropertyType.completionDates}`}
          options={completionDatesOptions}
          defaultValue={defaultValues[DeveloperPropertyType.completionDates]}
          onChange={(data: IDevelopmentSpecificationPropChange<ISpecificationProp>) => _onChange(data, `${propName}.${DeveloperPropertyType.completionDates}`)}
          {...register(`${propName}.${DeveloperPropertyType.completionDates}`)}
        />
        <Box width="100%" />
      </Box>
    </>
  );
};
